<template>
  <div style="width: 100%">
    <div  :model="formData">
      <el-row :gutter="60" style="font-size: large; line-height: 42px;text-align: center;">
        <el-col :span="3" style="margin-left: 20px">
          <el-select v-model="department_id" :placeholder="$t('ChanceBoard.department')" clearable>
            <el-option v-for="item in departmentList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-select v-model="user_id" :placeholder="$t('ChanceBoard.sales_user_id')" class="toolbar_item" clearable filterable>
            <el-option v-for="item in departmentUserList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-col>

        <el-button type="primary" style="margin-left: 20px;margin-top: 5px" @click="selectChance" :loading="loading">{{ $t('ChanceBoard.query') }}</el-button>
        <el-button type="primary" v-if="chanceDetails" style="margin-left: 30px;margin-top: 5px" @click="changeShow">{{ $t('ChanceBoard.Show_chance_distribution') }}</el-button>
        <el-button type="primary" v-if="funnelDetails" style="margin-left: 30px;margin-top: 5px" @click="changeShow">{{ $t('ChanceBoard.Show_sales_funnel') }}</el-button>

        <el-row style="width: 300px;margin-left: 150px">
          <el-col :span="10" class="val4">报备数量</el-col>
          <el-col :span="10" class="val5">{{ this.reportCnt }}/{{ this.reportLimit }}</el-col>
        </el-row>
        <el-row style="width: 300px;margin-left: 30px">
          <el-col :span="10" class="val4">{{ $t('ChanceBoard.chance_cnt') }}</el-col>
          <el-col :span="10" class="val5">{{ this.chanceCnt }}/{{ this.chanceLimit }}</el-col>
        </el-row>
      </el-row>
    </div>

    <!--  漏斗数据-->
    <el-card shadow="never" v-if="chanceDetails">
      <el-row>
        <template v-for="funnelItem in funnelData">
          <el-col span="6" class="funnel-box">
            <div class="title">{{ funnelItem.title }}</div>
            <div class="funnel">
              <div class="cnt">{{ funnelItem.cnt_d }}</div>
              <div class="cnt">{{ funnelItem.cnt_c }}</div>
              <div class="cnt">{{ funnelItem.cnt_b }}</div>
              <div class="cnt">{{ funnelItem.cnt_a }}</div>
              <div class="cnt end">
                <div class="cnt_f">{{ funnelItem.cnt_f }}</div>
                <div class="cnt_w">{{ funnelItem.cnt_w }}</div>
              </div>
            </div>
          </el-col>
        </template>
      </el-row>
    </el-card>

    <!--  工作量数据-->
    <el-card v-if="chanceDetails">
      <el-row>
        <template v-for="latestWorkItem in latestWorkData">
          <el-col span="8" style="font-size: large; line-height: 42px;text-align: center;padding: 0px 90px">
            <div class="wk title">{{ latestWorkItem.title }}</div>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.win_amount') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.sales_volume }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.win_number') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.win_cnt }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.fail_number') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.fail_cnt }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.level_rise') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.upgrade_cnt }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.level_decline') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.degrade_cnt }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.follow_number') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.follow_cnt }}</el-col>
            </el-row>
            <el-row style="width: 240px;">
              <el-col :span="12" class="val4">{{ $t('ChanceBoard.create_chance') }}</el-col>
              <el-col :span="12" class="val5">{{ latestWorkItem.create_chance_cnt }}</el-col>
            </el-row>
          </el-col>
        </template>
      </el-row>
    </el-card>


    <!--  机会分布数据-->
    <el-card shadow="never" v-if="funnelDetails" @node-click="nodeClickHandle">
      <el-row :gutter="0" style="font-size: large; line-height: 42px;text-align: center;">
        <template v-for="sceneItem in sceneList1">
          <el-col :span="2" class="val2" @click="searchByScene(sceneItem.value)">{{ sceneItem.name }}</el-col>
          <el-col :span="1" class="val3" @click="searchByScene(sceneItem.value)">{{
              sceneChance[sceneItem.value]
            }}
          </el-col>
        </template>
      </el-row>

      <el-row :gutter="0" style="font-size: large; line-height: 42px;text-align: center;">
        <template v-for="sceneItem in sceneList2">
          <el-col :span="2" class="val2" @click="searchByScene(sceneItem.value)">{{ sceneItem.name }}</el-col>
          <el-col :span="1" class="val3" @click="searchByScene(sceneItem.value)">{{
              sceneChance[sceneItem.value]
            }}
          </el-col>
        </template>
      </el-row>

      <div>
        <frame-query ref="frameQuery" componentParam="chance_details"
                     :parent-data="{department_id:this.department_id,sales_user_id:this.user_id, scene_id:this.scene_id}"></frame-query>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  name: "ChanceBoard",
  data() {
    return {

      funnelDetails: false,
      chanceDetails: true,
      msg: {},
      loading: false,
      user_id: '',
      department_id: '',
      scene_id: '',
      sceneList1: [{"name": "A", "value": "sales_level_1a"},
        {"name": "B", "value": "sales_level_2b"},
        {"name": "C", "value": "sales_level_3c"},
        {"name": "D", "value": "sales_level_4d"},
        {"name": "W", "value": "sales_level_5w"},
        {"name": "F", "value": "sales_level_6f"}],
      sceneList2: [{"name": this.$t('ChanceBoard.created_in_30_days'), "value": "created_in_30_days"},
        {"name": this.$t('ChanceBoard.no_follow_in_30_days'), "value": "no_follow_in_30_days"},
        {"name": this.$t('ChanceBoard.no_follow_in_60_days'), "value": "no_follow_in_60_days"},
        {"name": this.$t('ChanceBoard.no_level_up_30_days'), "value": "no_level_up_30_days"},
        {"name": this.$t('ChanceBoard.has_quote_in_30_days'), "value": "has_quote_in_30_days"},
        {"name": this.$t('ChanceBoard.has_contract_in_30_days'), "value": "has_contract_in_30_days"}],
      departmentList: [],
      departmentUserList: [],
      formData: {
        user_id: '',
        param1: ''
      },
      sceneChance: [],
      funnelData: [],
      latestWorkData: [],
      chanceData: [],
      chanceCnt: '',
      chanceLimit: '',
      reportCnt: '',
      reportLimit: ''
    }
  },
  computed: {
    i18n() {
      return this.$store.state.core.i18n
    },
  },
  methods: {
    clearData() {
      this.sceneChance = []
    },
    searchByScene(currentSceneId) {
      this.scene_id = currentSceneId;
      this.$refs.frameQuery.search();
    },

    changeShow() {
      if (this.funnelDetails == true) {
        this.funnelDetails = false
      } else {
        this.funnelDetails = true
      }
      if (this.chanceDetails == false) {
        this.chanceDetails = true
      } else {
        this.chanceDetails = false
      }
    },


    //获取默认销售
    async getSalesUser() {
      //this.user_id = await this.$http('sysUserDepartmentService.getCurrentUser')
      this.user_id = this.$store.state.core.currentUser.id
      this.selectChance()
    },

    //查询按钮
    selectChance() {
      this.clearData()
      if (this.department_id == "" && this.user_id == "") {
        return this.$message.error("请选择部门或人员");
      }
      //this.loading = true;
      this.getFunnelData()
      this.getLatestWorkData()
      this.getSceneChanceData()
      this.getBoardChanceCnt()
      this.getBoardChanceLimit()
      this.getBoardReportCnt()
      this.getBoardReportLimit()
      this.$refs.frameQuery.search();
      //this.loading = false;
    },

    //获取部门
    async getDepartmentList() {
      this.departmentList = await this.$http('sysDsService.getLeaderDepartments(sales)')
    },

    //当前用户下的销售
    async getDepartmentSalesList() {
      this.departmentUserList = await this.$http('sysDsService.getSubUsers(sales)')
    },

    //当前机会数量
    async getBoardChanceCnt() {
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.chanceCnt = await this.$http('chanceBoardService.getBoardChanceCnt', params)
    },

    //机会数量上限
    async getBoardChanceLimit() {
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.chanceLimit = await this.$http('chanceBoardService.getBoardChanceLimit', params)
    },

    //当前报备数量
    async getBoardReportCnt() {
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.reportCnt = await this.$http('chanceBoardService.getBoardReportCnt', params)
    },

    //报备数量上限
    async getBoardReportLimit() {
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.reportLimit = await this.$http('chanceBoardService.getBoardReportLimit', params)
    },

    //获取漏斗等级数据
    async getFunnelData() {
      this.clearData()
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.funnelData = await this.$http('chanceBoardService.getFunnelData', params)
    },

    //获取工作量详情数据
    async getLatestWorkData() {
      this.clearData()
      let params = {user_id: this.user_id, department_id: this.department_id};
      this.latestWorkData = await this.$http('chanceBoardService.getLatestWorkData', params)
    },

    //获取场景数据
    async getSceneChanceData() {
      this.clearData()
      let params = {sales_user_id: this.user_id, department_id: this.department_id};
      this.sceneChance = await this.$http('chanceBoardService.getSceneChanceCnt', params)
    },

  },
  created() {
    this.getDepartmentList()
    this.getDepartmentSalesList()
    this.getSalesUser()
  },
}
</script>

<style lang="less" scoped>
.detail-show {
  margin-top: 10px;
  padding: 15px 30px 5px 5px;
  border: 1px solid #ddd;
  min-height: 450px;
  word-break: break-all;
}

.doc-list {
  width: 100%;
  border: 1px solid lightblue;
  min-height: 100px;
}

.sales_ld {
  background-image: url("../../../../public/tmp/ld03.png");
  background-size: 100% 100%;
  width: 360px;
  height: 280px;
  font-size: x-large;
}

.ld_title {
  position: relative;
  left: 130px;
  top: -40px;
}

.sales_ld .cnt_d {
  position: relative;
  left: 156px;
  top: 8px;
  color: white;
}

.sales_ld .cnt_c {
  position: relative;
  left: 156px;
  top: 15px;
  color: white;
}

.sales_ld .cnt_b {
  position: relative;
  left: 163px;
  top: 20px;
  color: white;
}

.sales_ld .cnt_a {
  position: relative;
  left: 163px;
  top: 22px;
  color: white;
}

.sales_ld .cnt_w {
  position: relative;
  left: 165px;
  top: 40px;
  color: gold;
}

.sales_ld .cnt_f {
  position: relative;
  left: 40px;
  top: 5px;
  color: red;
}

.wk {
  font-size: x-large;
  line-height: 42px;
  color: black;
}

.wk.title {
  //border-bottom: 2px solid #ddd;
  //margin-bottom: 10px;
}

.val {
  background-color: coral;
  font-size: 20px;
  color: #fff;
}

.val2 {
  margin-left: 20px;
  margin-top: 10px;
  background-color: skyblue;
  color: #fff;
}

.val3 {
  margin-right: 20px;
  margin-top: 10px;
  font-size: 20px;
  background-color: coral;
  color: #fff;
}

.val4 {
  margin-top: 10px;
  background-color: skyblue;
  color: #fff;
}

.val5 {
  margin-top: 10px;
  background-color: coral;
  color: #fff;
}

.funnel-box {
  font-size: x-large;
  padding: 0 30px;

  .title {
    text-align: center;
  }

  .funnel {
    background-image: url("../../../../public/tmp/ld03.png");
    background-size: 100% 100%;
    width: 360px;
    height: 280px;
    padding-top: 50px;
    text-align: center;
    color: white;

    .cnt {
      height: 42px;
      line-height: 42px;
    }

    .end {
      position: relative;
    }

    .cnt_f {
      position: absolute;
      color: red;
      left: 22px;
      top: 5px;
      width: 55px;
    }

    .cnt_w {
      position: absolute;
      left: 150px;
      color: orange;
      top: 5px;
      width: 65px;
    }
  }


}


</style>